let scrollPage = () => {
    let result;
    let elements = document.querySelectorAll('.error-item');
    if( elements.length > 0 ) {
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: elements[0].offsetTop - 120
          });
        result = true;
    } else {
        result = false;
    }
    return result;
}

export default scrollPage;